import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { utilsService } from '../../core/services/utils.service';
import { LoadMoreWrapper } from '../load-more-wrapper/load-more-wrapper.jsx';
import { Truncate, RatingAsStars } from 'fn-common-ui';

@observer
export default class AppReviews extends React.Component {
  static propTypes = {
    reviews: PropTypes.object
  };

  static defaultProps = {
    reviews: []
  };

  renderReviews = (reviews) => {
      return reviews.map((node) => {
        let authorName = `${node.userFirstName} ${node.userLastName}`;

        return (
          <div
            key={node.reviewId}
            className="individual-review-container"
            tabIndex={0}
            aria-labelledby={'Review-' + node.reviewId}>
            <div className="author-and-rating-container">
              <div className="review-author">{authorName}</div>
              <div className="sr-only">
                {'App rated ' + node.rating + ' out of 5'}
              </div>
              <RatingAsStars
                rating={node.reviewStar}
                showRatingNumber={false} />
              <div className="review-subject" id={'Review-' + node.reviewId}>
                {node.commentTitle}
              </div>
            </div>
            <div className="review-date">
              {utilsService.normalizedDate(node.reviewDate)}
            </div>
            {node.comment && (
              <Truncate className="comment-container" charLimit={300}>
                {node.comment}
              </Truncate>
            )}
          </div>
        );
      });
  }

  render() {
    return (
      <div className="reviews-container">
        <LoadMoreWrapper isLoading={false} itemsPerPage={20}>
          {this.renderReviews(this.props.reviews)}
        </LoadMoreWrapper>
      </div>
    );
  }
}
